import "twin.macro";

import { useSelector } from "react-redux";

import { Alert } from "@mui/material";

import { Type } from "@features/ui";

const ConfigurationWarnings = () => {
  const {
    channels,
    territories,
    organization: { usesChannels },
  } = useSelector((state: any) => state.currentUser);

  return (
    <div tw="space-y-2 empty:hidden">
      {usesChannels && channels.length === 0 && (
        <Alert severity="warning" tw="shadow-md">
          <Type.H2 tw="text-amber-900 mb-1">
            No channels are configured for this organization.
          </Type.H2>
          <Type.P tw="text-amber-800">
            You won't be able to use brandhub without channels. Please contact
            your administrator.
          </Type.P>
        </Alert>
      )}
      {territories.length === 0 && (
        <Alert severity="warning" tw="shadow-md">
          <Type.H2 tw="text-amber-900 mb-1">
            No territories are configured for this organization.
          </Type.H2>
          <Type.P tw="text-amber-800">
            You won't be able to use brandhub without territories. Please
            contact your administrator.
          </Type.P>
        </Alert>
      )}
    </div>
  );
};

export default ConfigurationWarnings;
